/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

const NavbarDropdownHeader = ({ id, link, children }) => (
  <a
    className="dropdown-toggle nav-link"
    id={id}
    role="button"
    aria-haspopup="true"
    aria-expanded="false"
    data-toggle="dropdown"
    data-display="static"
    href={link}
  >
    {children}
  </a>
);

NavbarDropdownHeader.defaultProps = {
  link: '#'
};

NavbarDropdownHeader.propTypes = {
  id: PropTypes.string.isRequired,
  link: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default NavbarDropdownHeader;
